import http from '../utils/api';
import moment from "moment";
import localforage from "../utils/localforage";

export const filter = (cb) => (initial, newData) => {
    const filterApontamento = {
        ...newData,
        dataHoraInicio: moment(newData.dataHoraInicio).set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
        }).toISOString(),
        dataHoraFim: moment(newData.dataHoraFim).set({
            hour: 23,
            minute: 59,
            second: 59,
            millisecond: 999
        }).toISOString(),
    };
    localforage.setItem(
        'filterApontamento',
        filterApontamento
    ).then();
    http.get(
        'apontamentos',
        {
            params: filterApontamento
        }
    ).then(({data}) => {
        localforage.setItem('dataHoraInicio', data.data).then(() => {
            cb(data.data);
        })
        return data.data;
    }).catch()
};

export function getByAtividadesProjeto(val) {
    return http.get(`atividades-alocadas`, {
        params: {
            IdAtividadeProjeto: val,
        }
    }).then(({data:{data}}) => {
        const first = data?.[0];
        first.atividadeAlocada = first.descricao;
        first.descricao = null;
        return first;
    })
}


export function getAllocatedPendecyStatus(val, data) {
    return http.get(`atividades-alocadas/pendencia`, {
        params: {
            idPendencia: val,
            data
        }
    })
}

export function allocatePendency(val, dataConsulta) {
    return http.post('atividades-alocadas/alocar-pendencia', {...val, dataAlocacao: dataConsulta}).then(() => {
        return getAllocatedPendecyStatus(val.idPendencia, dataConsulta)
    }).catch(e => {
        console.error('erro allocatePendency', e)
        throw e
    })
}

export const checkPendencyId = (form) => (e) => {
    console.log(form)
    e.persist();
    if (e.relatedTarget?.closest('.clear')) {
        return form.setFieldValue(e.target.name, '')
    }
    if (!e.target.value)
        return;
    // return form.handleReset();
    const idPendencia = e.target.value;
    const dataConsulta = moment(form.values.dataHoraInicio).format('YYYY-MM-DD')
    getAllocatedPendecyStatus(e.target.value, dataConsulta).then(({data: {data}}) => {
        let first = data[0];
        let confirm;
        if (first.status === 'CONFIRMACAO' && (confirm = window.confirm(first.resultado))) {
            allocatePendency({
                idPendencia,
                idProjeto: first.idProjeto
            }, dataConsulta).then(({data: {data}}) => {
                const dataPendency = data[0];
                if (!dataPendency?.idAtividadeAlocada) {
                    form.setFieldValue(e.target.name, form.initialValues[e.target.name]);
                    window.alert(dataPendency.resultado);
                } else {
                    form.setValues({
                        ...form.initialValues,
                        ...form.values,
                        descricao: form.values.descricao,
                        ...dataPendency,
                        atividadeAlocada: dataPendency.atividadeAlocada ?? dataPendency.titulo,
                        tipoCapacitacao: dataPendency.tipoCapacitacao || null,
                        opcoesCapacitacao: dataPendency.opcoesCapacitacao || [],
                        codTipoCapacitacao: null,
                    });
                }
            }).catch(() => {
                form.setFieldValue('pendenciaId', form.initialValues.pendenciaId);
                window.alert("Erro ao alocar pendencia!");
            })
        } else if (first.status === 'CONFIRMACAO' && !confirm)
            return form.handleReset();
        else if (first.status === 'OK') {
            form.setValues({
                ...form.initialValues,
                ...form.values,
                descricao: form.values.descricao,
                ...first,
                pendenciaId: idPendencia,
                atividadeAlocada: first.atividadeAlocada ?? first.titulo,
                tipoCapacitacao: first.tipoCapacitacao || null,
                opcoesCapacitacao: first.opcoesCapacitacao || [],
                codTipoCapacitacao: null,
            });
        } else if (first.status === 'ERRO') {
            form.setFieldValue('pendenciaId', form.initialValues.pendenciaId);
        }
    }).catch((e) => {
        console.log('error', e)
        form.setFieldValue('pendenciaId', form.initialValues.pendenciaId);
        window.alert("Erro ao buscar a pendencia!");
    })
};
